import { observer } from 'mobx-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Block, Heading } from 'suomifi-ui-components'
import LocalizedString from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'
import { Divider } from 'todistukset-ui/src/vtj/components/order-wizard-aet-shared/AetOrderSummary/AetSummaryPriceInfo.sc'
import PriceInfoRow from 'todistukset-ui/src/vtj/components/order-wizard-aet-shared/AetOrderSummary/PriceInfoRow.react'

const AetSummaryPriceInfo: React.FC = observer(() => {
  const { t } = useTranslation()
  return (
    <Block variant="section">
      <Heading variant="h3">
        <LocalizedString stringKey="aetSummaryPriceInfoTitle" />
      </Heading>
      <PriceInfoRow
        leftContent={t('aetSummaryPriceInfoAet')}
        rightContent={t('aetSummaryPriceInfoNoFee')}
      />
      <Divider />
      <PriceInfoRow
        leftContent={t('aetSummaryPriceInfoTotal')}
        rightContent={t('aetSummaryPriceInfoNoFee')}
        bold
      />
    </Block>
  )
})

export default AetSummaryPriceInfo
